export default "__VITE_ASSET__CNCOAMMh__"